export default {

    domain: process.env.NODE_ENV !== 'development' ? 'https://wms.zzbeilei.com/api' : 'http://localhost:9102/',
    domainName: 'wms 系统',

}